import { createGlobalStyle, type DefaultTheme } from "styled-components";

const shared = {
  radii: { sm: "10px", md: "18px", lg: "28px", pill: "999px" },
  spacing: { xs: ".5rem", sm: ".75rem", md: "1rem", lg: "1.5rem", xl: "2.5rem", xxl: "5rem" },
  maxWidth: "1180px"
};

export const darkTheme: DefaultTheme = {
  ...shared,
  mode: "dark",
  colors: {
    canvas: "#061522",
    canvasAlt: "#091d2e",
    surface: "rgba(14, 39, 59, .72)",
    surfaceElevated: "#102c43",
    text: "#f5f9fc",
    muted: "#a9bdcc",
    border: "rgba(160, 205, 232, .17)",
    primary: "#45b7ff",
    primaryStrong: "#158fdb",
    accent: "#15c875",
    accentSoft: "rgba(21, 200, 117, .14)",
    danger: "#ff6b75",
    shadow: "rgba(0, 0, 0, .35)"
  }
};

export const lightTheme: DefaultTheme = {
  ...shared,
  mode: "light",
  colors: {
    canvas: "#f7fafc",
    canvasAlt: "#edf5f9",
    surface: "rgba(255, 255, 255, .84)",
    surfaceElevated: "#ffffff",
    text: "#092033",
    muted: "#526b7c",
    border: "rgba(12, 54, 80, .14)",
    primary: "#087cc1",
    primaryStrong: "#05659e",
    accent: "#07985a",
    accentSoft: "rgba(7, 152, 90, .11)",
    danger: "#c93544",
    shadow: "rgba(21, 59, 84, .13)"
  }
};

export const GlobalStyle = createGlobalStyle`
  :root { font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif; }
  * { box-sizing: border-box; }
  html { scroll-behavior: smooth; }
  body {
    margin: 0;
    color: ${({ theme }) => theme.colors.text};
    background:
      radial-gradient(circle at 12% 8%, rgba(69,183,255,.13), transparent 24rem),
      radial-gradient(circle at 86% 12%, rgba(21,200,117,.1), transparent 22rem),
      ${({ theme }) => theme.colors.canvas};
    min-width: 320px;
    line-height: 1.6;
    text-rendering: optimizeLegibility;
  }
  body, button, input, select, textarea { font: inherit; }
  a { color: inherit; }
  img, svg { max-width: 100%; }
  button, a { -webkit-tap-highlight-color: transparent; }
  :focus-visible { outline: 3px solid ${({ theme }) => theme.colors.accent}; outline-offset: 3px; }
  .skip-link {
    position: fixed; left: 1rem; top: -5rem; z-index: 9999; background: #fff; color: #071827;
    padding: .7rem 1rem; border-radius: 10px; font-weight: 800;
  }
  .skip-link:focus { top: 1rem; }
  @media (prefers-reduced-motion: reduce) {
    *, *::before, *::after { animation-duration: .01ms !important; animation-iteration-count: 1 !important; scroll-behavior: auto !important; transition-duration: .01ms !important; }
  }
`;
